import { useState, useEffect } from 'react';
import '../styles/StatsSection.css';

const COUNTER_START = 468996716;
const INCREMENT_MS = 1000;

function FastStat() {
  const [count, setCount] = useState(COUNTER_START);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => prev + 1);
    }, INCREMENT_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="stat-row">
      <div className="stat-row__media">
        <video
          className="stat-row__video"
          autoPlay
          muted
          loop
          playsInline
          src={`${process.env.PUBLIC_URL}/videos/fast-graphic.webm`}
        />
      </div>
      <div className="stat-row__content">
        <h3 className="stat-row__title">Fast</h3>
        <p className="stat-row__number">{count.toLocaleString()}</p>
        <p className="stat-row__subtext">1.1s avg block time with single-slot finality</p>
      </div>
    </div>
  );
}

function DecentralizedStat() {
  return (
    <div className="stat-row stat-row--reverse">
      <div className="stat-row__content">
        <h3 className="stat-row__title">Decentralized</h3>
        <p className="stat-row__number">100 Data Providers</p>
        <p className="stat-row__subtext">3.3% maximum stake per data provider</p>
      </div>
      <div className="stat-row__media">
        <video
          className="stat-row__video"
          autoPlay
          muted
          loop
          playsInline
          src={`${process.env.PUBLIC_URL}/videos/decentralized-graphic.webm`}
        />
      </div>
    </div>
  );
}

function ProgressRing({ percent }) {
  const radius = 32;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <svg className="progress-ring" width="76" height="76" viewBox="0 0 76 76">
      <circle
        className="progress-ring__track"
        cx="38"
        cy="38"
        r={radius}
        strokeWidth="6"
        fill="none"
      />
      <circle
        className="progress-ring__fill"
        cx="38"
        cy="38"
        r={radius}
        strokeWidth="6"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
      <text x="38" y="38" className="progress-ring__label" textAnchor="middle" dominantBaseline="middle">
        {percent}%
      </text>
    </svg>
  );
}

function SecureStat() {
  return (
    <div className="stat-row">
      <div className="stat-row__media">
        <video
          className="stat-row__video"
          autoPlay
          muted
          loop
          playsInline
          src={`${process.env.PUBLIC_URL}/videos/secure-graphic.webm`}
        />
      </div>
      <div className="stat-row__content">
        <h3 className="stat-row__title">Secure</h3>
        <div className="stat-row__ring-line">
          <ProgressRing percent={76} />
          <div className="stat-row__ring-text">
            <p className="stat-row__number stat-row__number--tight">FLR Staked</p>
            <p className="stat-row__subtext">of which 97% is from the community</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function StatsSection() {
  return (
    <section className="stats">
      <FastStat />
      <DecentralizedStat />
      <SecureStat />
    </section>
  );
}

export default StatsSection;